import { render, staticRenderFns } from "./Jumbotrons.vue?vue&type=template&id=4d88f618"
import script from "./Jumbotrons.vue?vue&type=script&lang=js"
export * from "./Jumbotrons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports